import { Colors, Flex, IconEmptyZzim, RemoteImage } from '@banhala/ui-kit';
import type { LikeFolder } from 'shared/src/api/likedFolderService/getLikedFolders/types';

const SIZE = 40;

interface FolderThumbnailProps {
  folder: LikeFolder;
}

export const FolderThumbnail = ({ folder }: FolderThumbnailProps) => {
  const image = folder.cover_image ?? folder.goods_images[0] ?? null;

  if (image == null) {
    return (
      <Flex.Center
        width={SIZE}
        height={SIZE}
        backgroundColor={'bg_secondary'}
        borderRadius={'small'}
      >
        <IconEmptyZzim size={24} fill={Colors.border_secondary} />
      </Flex.Center>
    );
  }

  return (
    <RemoteImage
      uri={image}
      width={SIZE}
      height={SIZE}
      borderRadius={'small'}
      doAnimate={false}
    />
  );
};
